import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AppMode } from '../models/app-mode.model';
import { AppModeService } from './app-mode.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AppModeGuard implements CanActivate {
  constructor(
    private appModeService: AppModeService,
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const allowedModes = (route.data?.['appModes'] as AppMode[] | undefined) ?? undefined;
    const allowAdminAccess = route.data?.['allowAdmin'] === true;

    if (!allowedModes || allowedModes.length === 0) {
      return true;
    }

    if (allowAdminAccess && this.authService.isCurrentUserAdmin()) {
      return true;
    }

    const currentMode = this.appModeService.getAppMode();
    if (allowedModes.includes(currentMode)) {
      return true;
    }

    const redirectTo = route.data?.['redirectTo'] as string | undefined;
    if (redirectTo) {
      return this.router.parseUrl(redirectTo);
    }

    return this.router.parseUrl('/dashboard');
  }
}
